import { render } from "./leadermanger.vue?vue&type=template&id=c84bfa48&scoped=true&ts=true"
import script from "./leadermanger.vue?vue&type=script&lang=ts"
export * from "./leadermanger.vue?vue&type=script&lang=ts"

import "./leadermanger.vue?vue&type=style&index=0&id=c84bfa48&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84bfa48"]])

export default __exports__